import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';

const DirectPaymentOrderNotFound = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation(['Modal', 'Button']);

  return (
    <Modal title={t('DirectPaymentOrderNotFound.title')}>
      <p>{t('DirectPaymentOrderNotFound.body')}</p>
      <ModalActions>
        <Button onClick={closeModal}>{t('Button:close')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default DirectPaymentOrderNotFound;
